import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type EsCollection } from '@app/client';
import { type FreshCollection } from '@app/store/zustand';

// TODO consider renaming FreshCollection

export type RecentCollection = FreshCollection & { player_count: EsCollection['player_count'] };
//TODO - consolidat3e collection card types
export interface RecentPicksData {
    recentlyPickedCollections: RecentCollection[];
    queuedCollections: RecentCollection[];
}
export type CollectionStoreType = keyof RecentPicksData;
export interface RecentPicksState extends RecentPicksData {
    addCollections: (type: CollectionStoreType, newCollections: RecentCollection[]) => void;
    showQueuedCollections: () => void;
    clearRecentCollections: () => void;
}

const initialDataState: RecentPicksData = {
    recentlyPickedCollections: [],
    queuedCollections: [],
};
export const useFantasyRecentPicks = create<RecentPicksState>()(
    devtools(
        (set) => ({
            ...initialDataState,
            addCollections: (type, newCollections) =>
                set(() => {
                    return { [type]: newCollections };
                }),
            showQueuedCollections: () =>
                set((state) => {
                    const updatedCollections = [
                        ...new Set([...state.queuedCollections, ...state.recentlyPickedCollections]),
                    ];
                    return { recentlyPickedCollections: updatedCollections, queuedCollections: [] };
                }),
            clearRecentCollections: () => set(initialDataState),
        }),
        { name: 'fantasy-recent-picks-storage' },
    ),
);
